export const SET_HRES7FE_INDEX_DISP = 'SET_HRES7FE_INDEX_DISP'
export const GET_HRES7FE_INDEX_DISP = 'GET_HRES7FE_INDEX_DISP'
export const SET_HRES7FE_DETAIL_DISP = 'SET_HRES7FE_DETAIL_DISP'
export const GET_HRES7FE_DETAIL_DISP = 'GET_HRES7FE_DETAIL_DISP'
export const TOGGLE_HRES7FE_PAGE = 'TOGGLE_HRES7FE_PAGE'
export const SET_HRES7FE_COLUMNS = 'SET_HRES7FE_COLUMNS'
export const GET_HRES7FE_COLUMNS = 'GET_HRES7FE_COLUMNS'
export const SET_HRES7FE_LABELS = 'SET_HRES7FE_LABELS'
export const GET_HRES7FE_LABELS = 'GET_HRES7FE_LABELS'
export const GET_HRES7FE_MAX_ROWSPAN = 'GET_HRES7FE_MAX_ROWSPAN'
export const RECEIVED_HRES7FE_COLUMNS_LABELS = 'RECEIVED_HRES7FE_COLUMNS_LABELS'
export const SET_HRES7FE_INDEX = 'SET_HRES7FE_INDEX'
export const GET_HRES7FE_INDEX = 'GET_HRES7FE_INDEX'
export const SET_HRES7FE_INDEX_SELECTED = 'SET_HRES7FE_INDEX_SELECTED'
export const GET_HRES7FE_INDEX_SELECTED = 'GET_HRES7FE_INDEX_SELECTED'
export const POST_HRES7FE_TAB1_SAVE = 'POST_HRES7FE_TAB1_SAVE'
export const POST_HRES7FE_TAB2_SAVE = 'POST_HRES7FE_TAB2_SAVE'
export const POST_HRES7FE_INDEX_CANCEL = 'POST_HRES7FE_INDEX_CANCEL'
export const RECEIVED_HRES7FE_INDEX = 'RECEIVED_HRES7FE_INDEX'
export const SET_HRES7FE_DETAIL = 'SET_HRES7FE_DETAIL'
export const GET_HRES7FE_DETAIL = 'GET_HRES7FE_DETAIL'
export const RECEIVED_HRES7FE_DETAIL = 'RECEIVED_HRES7FE_DETAIL'



// WEBPACK FOOTER //
// ./src/store/modules/hres7fe/mutation-types.js